import { DataPrepLayerGroup, DataPrepStatus, getDataPrepStatus, GroupLayer } from "fond/project/panels/RunDataPrep/dataPrepStatus";
import { MuPowerEditableLayerIds, MuPowerInputLayerIds } from "fond/types";

import { muPowerInputLayers } from "./InputPanel/layers";

const muPowerLayerGroups: Record<DataPrepLayerGroup, GroupLayer[]> = {
  inputs: muPowerInputLayers.filter(({ isRequired }) => isRequired).map(({ key, displayName }) => ({ id: key, name: displayName })),
  underground: [
    { id: MuPowerEditableLayerIds.ugPath, name: "Underground path" },
    { id: MuPowerEditableLayerIds.ugPoints, name: "Underground points" },
  ],
  aerial: [{ id: MuPowerInputLayerIds.poles, name: "Poles" }],
  leadins: [{ id: MuPowerEditableLayerIds.leadins, name: "Leadins" }],
};

/** Ids of every layer the MU Power data prep status depends on. */
export const muPowerDataPrepStatusLayerIds = Object.values(muPowerLayerGroups).flatMap((layers) => layers.map(({ id }) => id));

/** The current status of MU Power layer groups relevant to data prep. */
export const getMuPowerDataPrepStatus = (layerKeys: string[]): DataPrepStatus =>
  // MU_POWER doesn't have aerial edges, so only the underground group can form a candidate network
  getDataPrepStatus(layerKeys, muPowerLayerGroups, ["underground"]);
